import styled from 'styled-components';

export const Wrapper = styled.div`
  min-height: 92px;
  border: 1px solid ${({ theme }) => theme.borders.workspaceItem};
  background-color: ${({ theme }) => theme.backgrounds.workspaceItem};
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.actionBar};
`;

export const Text = styled.div`
  font-size: 13.5px;
  line-height: 1.45;
  color: ${({ theme }) => theme.text.workspaceItem};
`;
